import { useRef } from 'react';
import CustomPaginate from './CustomPaginate';

const NofollowReactPaginate = (props: any) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  return props.pageCount < 2 ? (
    <></>
  ) : (
    <div ref={wrapperRef}>
      <CustomPaginate
        pageCount={props.pageCount}
        forcePage={props.forcePage}
        pageRangeDisplayed={props.pageRangeDisplayed}
        marginPagesDisplayed={props.marginPagesDisplayed}
        previousLabel={props.previousLabel}
        nextLabel={props.nextLabel}
        onPageChange={props.onPageChange}
        onPageActive={props.onPageActive}
        hrefBuilder={props.hrefBuilder}
        hrefAllControls={props.hrefAllControls}
        relation="nofollow"
      />
    </div>
  );
};

export default NofollowReactPaginate;
